import { defineMessages } from "react-intl";

const PREFIX = "CalendarHierarchy";
const messages = defineMessages({
  selectAllButtonLabel: {
    id: `${PREFIX}.selectAllButtonLabel`,
    defaultMessage: "Select all",
  },
  unselectAllButtonLabel: {
    id: `${PREFIX}.unselectAllButtonLabel`,
    defaultMessage: "Unselect all",
  },
  apllyButtonLabel: {
    id: `${PREFIX}.apllyButtonLabel`,
    defaultMessage: "Apply",
  },
  cancelButtonLabel: {
    id: `${PREFIX}.cancelButtonLabel`,
    defaultMessage: "Cancel",
  },
});

export default messages;
